import { Typography } from '@/components';
import { TextStyles } from '@/constants';
import styled from 'styled-components';

const clampText = `
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
`;

export const EmailVerificationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex: 1;
  padding-left: ${({ theme }) => theme.spacing[16]}px;
  padding-right: ${({ theme }) => theme.spacing[16]}px;

  ${({ theme }) => theme.mediaBreakpointUp.lg} {
    padding-left: ${({ theme }) => theme.spacing[40]};
    padding-right: ${({ theme }) => theme.spacing[40]};
  }
`;

export const VerificationTitle = styled(Typography).attrs({
  variant: TextStyles['Heading 3'],
})`
  color: ${({ theme }) => theme.colors.highEmphasisBlack};

  ${clampText}
  -webkit-line-clamp: 3;
  word-break: break-word;
`;

export const VerificationSubtext = styled(Typography).attrs({
  variant: TextStyles['Body Text Large'],
})`
  color: ${({ theme }) => theme.colors.highEmphasisBlack};
  line-height: ${({ theme }) => theme.lineHeight[22]};

  ${clampText}
  -webkit-line-clamp: 3;
  word-break: break-word;

  ${({ theme }) => theme.mediaBreakpointUp.md} {
    margin-top: ${({ theme }) => theme.spacing[4]};
  }
`;

export const VerificationEmail = styled(Typography).attrs({
  variant: TextStyles['Heading 5'],
})`
  color: ${({ theme }) => theme.colors.highEmphasisBlack};
  margin-top: ${({ theme }) => theme.spacing[16]};
`;
